module.exports = __webpack_public_path__ + "media/images/gift-thanks-writer-bg-candy@3x-443203d8fe42c29cf1089f03fdb62b40.png";